import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from "@angular/router";
import { AuthService } from "../Services/auth";
import { EncryptionService } from "../Services/encryption/encryption.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private encryptionService: EncryptionService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    try {
      if (
        this.authService &&
        this.authService.isLoggedIn &&
        this.authService.isLoggedIn()
      ) {
        // let binExist = this.encryptionService.decrypt(
        //   localStorage.getItem("bin")?.toString() || "",
        // );

        // if (binExist !== "") {
        //   this.authService.checkSessionValidity(binExist).subscribe({
        //     next: (resp: any) => {
        //       console.log(resp);
        //       try {
        //         const sessionData = resp?.response || {};
        //         if (sessionData.is_session_active === "N") {
        //           return false;
        //         } else {
        //           return true;
        //         }
        //       } catch (err) {
        //         // console.log(err);
        //         return false;
        //       }
        //     },
        //   });
        // }
        return true;
      }
    } catch (e) {
      console.warn("AuthGuard check failed", e);
    }
    // Not logged in — redirect to root (login) and preserve intended URL
    return this.router.createUrlTree([""], {
      queryParams: { returnUrl: state.url },
    });
  }
}
